const joinUmlauts = letter => {
  switch (letter) {
    case 'ä':
      return 'a';
    case 'ü':
      return 'u';
    case 'ö':
      return 'o';
    default:
      return letter;
  }
};

export default joinUmlauts;
